import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "message-container",
  class: "message-container display"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "chatbot-header" }, [
  /*#__PURE__*/_createVNode("h4", null, "Let's Chat"),
  /*#__PURE__*/_createVNode("div", {
    class: "close-cross toggled-btn",
    id: "close-btn"
  }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-minus" })
  ])
], -1)
const _hoisted_3 = {
  class: "convo-talk",
  id: "botMessage"
}
const _hoisted_4 = { class: "convo-chat" }
const _hoisted_5 = { class: "convo-img" }
const _hoisted_6 = { class: "convo-text" }
const _hoisted_7 = { class: "chatbox begin" }
const _hoisted_8 = /*#__PURE__*/_createVNode("strong", null, "Hi There! I'm ConvoChat. How may we assist you?", -1)
const _hoisted_9 = { class: "chatbox middle" }
const _hoisted_10 = {
  key: 0,
  class: "client-chat"
}
const _hoisted_11 = { class: "client-text client-begin" }
const _hoisted_12 = { class: "chat-time" }
const _hoisted_13 = {
  key: 1,
  class: "convo-chat"
}
const _hoisted_14 = { class: "convo-img" }
const _hoisted_15 = { class: "convo-text" }
const _hoisted_16 = { class: "chatbox begin" }
const _hoisted_17 = { class: "chat-time" }
const _hoisted_18 = {
  key: 1,
  class: "chatbox middle image_elements"
}
const _hoisted_19 = { class: "chat-time" }
const _hoisted_20 = {
  key: 2,
  class: "chatbox final"
}
const _hoisted_21 = { class: "embed-responsive embed-responsive-16by9" }
const _hoisted_22 = {
  class: "thumbnail grouped_elements",
  "data-fancybox": "group1",
  href: "img/How to Manage Projects Online - Project Management Training.mp4"
}
const _hoisted_23 = {
  class: "embed-responsive-item",
  controls: "",
  poster: "img/logo fav.png",
  id: "banner-video",
  preload: "auto",
  allowfullscreen: ""
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_25 = {
  key: 0,
  class: "chat-load"
}
const _hoisted_26 = { class: "send-message" }
const _hoisted_27 = { class: "type-text d-flex" }
const _hoisted_28 = { class: "container" }
const _hoisted_29 = {
  key: 0,
  class: "send"
}
const _hoisted_30 = {
  key: 1,
  class: "send disabled button"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("button", null, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-paper-plane" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_P = _resolveComponent("P")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("img", {
            src: 
              _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/logo fav.png`
                : 'img/logo fav.png'
            ,
            alt: ""
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_P, null, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("img", {
              src: 
                _ctx.state.data.imageBaseUrl
                  ? `${_ctx.state.data.imageBaseUrl}img/convo-chat.jpg`
                  : 'img/convo-chat.jpg'
              ,
              alt: ""
            }, null, 8, ["src"])
          ])
        ])
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.answers, (message, idx) => {
        return (_openBlock(), _createBlock("div", {
          class: "convo-div",
          key: idx
        }, [
          (message.question != null)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_P, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(message.question), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("p", null, _toDisplayString(message.question_time), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (message.answer != null)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("img", {
                    src: 
                _ctx.state.data.imageBaseUrl
                  ? `${_ctx.state.data.imageBaseUrl}img/logo fav.png`
                  : 'img/logo fav.png'
              ,
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("p", null, _toDisplayString(message.answer), 1),
                    _createVNode("div", _hoisted_17, [
                      _createVNode("p", null, _toDisplayString(message.answer_time), 1)
                    ])
                  ]),
                  (message.redirectTo!='null')
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "click-link",
                        onClick: ($event: any) => (_ctx.redirectToRoute(message.redirectTo))
                      }, "Click Me", 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (message.type == 'image')
                    ? (_openBlock(), _createBlock("div", _hoisted_18, [
                        _createVNode("img", {
                          src: message.file,
                          "data-fancybox": "group1",
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("div", _hoisted_19, [
                          _createVNode("p", null, _toDisplayString(message.answer_time), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (message.type == 'video')
                    ? (_openBlock(), _createBlock("div", _hoisted_20, [
                        _createVNode("div", _hoisted_21, [
                          _createVNode("a", _hoisted_22, [
                            _createVNode("video", _hoisted_23, [
                              _createVNode("source", {
                                src: message.file,
                                type: "video/mp4"
                              }, null, 8, ["src"]),
                              _createVNode("source", {
                                src: message.file,
                                type: "video/ogg"
                              }, null, 8, ["src"]),
                              _hoisted_24
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_ctx.state.ui.postLoading.sendQuestion)
        ? (_openBlock(), _createBlock("div", _hoisted_25, [
            _createVNode("img", {
              src: 
            _ctx.state.data.imageBaseUrl
              ? `${_ctx.state.data.imageBaseUrl}img/chat-loading.gif`
              : 'img/chat-loading.gif'
          ,
              alt: ""
            }, null, 8, ["src"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_26, [
      _createVNode("div", _hoisted_27, [
        _createVNode("div", _hoisted_28, [
          _withDirectives(_createVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.question = $event)),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendQuestion && _ctx.sendQuestion(...args)), ["enter"])),
            placeholder: "Type your message here..."
          }, null, 544), [
            [_vModelText, _ctx.state.data.question]
          ]),
          (_ctx.state.data.question != '')
            ? (_openBlock(), _createBlock("div", _hoisted_29, [
                _createVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendQuestion && _ctx.sendQuestion(...args)))
                }, [
                  _createVNode("i", {
                    class: "fas fa-paper-plane",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendQuestion && _ctx.sendQuestion(...args)))
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.data.question == '')
            ? (_openBlock(), _createBlock("div", _hoisted_30, [
                _hoisted_31
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}